import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import GoBackArrow from '../../shared/GoBackArrow/go.back.arrow.vue';
@Component({
    components: {
        GoBackArrow
    }
 })
export default class HybridBasicLayout extends Vue {
}
